import React from 'react';
import { NavLink } from 'react-router-dom';
import { withRouter } from 'react-router-dom';

import WP from 'WP';

const SmartLink = props => {

    const { to, target, children, className, onClick } = props;
    if(to === undefined || to === null) return <a/>;
    const internal = to.indexOf(WP.home) !== -1 || to[0] === '/';

    // if link is internal - remove the domain
    let url = internal ? to.replace(WP.home, '') : to;

    // make sure internal links start from '/'
    if(internal && url[0] !== '/') url = '/'+url;

    // make sure english links start form /en/
    if(internal && WP.lang === 'en' && url.indexOf('/'+WP.lang+'/') === -1 )
        url = '/'+WP.lang+url;

    return internal ? 
        <NavLink className={className} onClick={e => onClick ? onClick(e) : false } to={url} >{children}</NavLink>
        :
        <a className={className} onClick={e => onClick ? onClick(e) : false } href={url} target={target}>{children}</a>
}

export default withRouter(SmartLink);


// WEBPACK FOOTER //
// ./src/partials/SmartLink.js